import type { ContentTagMatchType } from '@/apis/queries/media-list.types';

export type { ContentTagMatchType };

export const DEFAULT_CONTENT_TAG_MATCH_TYPE: ContentTagMatchType = 'ANY';

export const CONTENT_TAG_MATCH_TYPE_OPTIONS: { value: ContentTagMatchType; label: string }[] = [
  { value: 'ANY', label: 'Match Any' },
  { value: 'ALL', label: 'Match All' },
];

/**
 * Filter-bag keys owned by ContentTagFilterPanel. Intersect into a scope's filter type so the
 * slot props it is bound to narrow past dashing-ui's untyped `{ [name: string]: unknown }`.
 */
export type ContentTagFilters = {
  contentTags?: string[];
  contentTagMatchType?: ContentTagMatchType;
};
